import Security from '../../../settings/components/Security';

const SecurityPage = () => {
    return <Security />;
};

export default SecurityPage;
